import React from 'react'
import { LegalMarkdown } from '@/components/legal-markdown'
import { germanTermsV1 } from './content/german-terms-v1'
import { germanTermsV2 } from './content/german-terms-v2'

interface GermanUserTermsAndConditionsProps {
    version: number
}

export const GermanUserTermsAndConditions: React.FC<GermanUserTermsAndConditionsProps> = ({
    version,
}) => {
    const content = version === 2 || version === 0 ? germanTermsV2 : germanTermsV1

    return <LegalMarkdown content={content} />
}
